module.exports = __webpack_public_path__ + "img/statistics.5e22ee90.svg";